const AppLoader = require('tui-app-loader');
const appLoader = new AppLoader({
    usageStatistics: false
});

export default class {

    execute(targetScheme, etcCallback = null, notFoundCallback = null) {

        appLoader.exec({
            ios: {
                scheme: targetScheme.ios,
                url: 'https://itunes.apple.com/app/id1469194764',

            },
            android: {
                intentURI: targetScheme.aos
            },
            timerSet: {
                ios: 2000
            },
            etcCallback: function () {
                if (etcCallback != null) {
                    etcCallback()
                }
            },
            notFoundCallback: function () {
                if (notFoundCallback != null) {
                    notFoundCallback()
                }
            }
        });
    }
}